export const ItemStatus = Object.freeze({
  STARTED: 'STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE',
  FINALISED: 'FINALISED',
  ARCHIVED: 'ARCHIVED',
  DELETED: 'DELETED',
});

export default ItemStatus;
